export interface AdminMenuState {
    open: boolean;
}

export const initialState: AdminMenuState = {
    open: false,
};



// WEBPACK FOOTER //
// ./src/store/AdminMenuState.ts